import { stores } from '@kurtosys/app-start';
import { components } from '@kurtosys/ksys-app-components';
import { IEntity } from '@kurtosys/types/api/search/index.js';
import { IConfigurationComponentOrchestration } from '@kurtosys/types/app/index.js';
import { IExecutionOptions, IQueryOptions } from '@kurtosys/types/query/index.js';
import { computed, observable } from 'mobx';

import { IComponentStyles, IConfiguration, TStoreContext } from '../../../models/index.js';

import { AppStore } from './AppStore.js';
import { DocumentListStore } from './DocumentListStore.js';

type IHeadingProps = components.base.Heading.models.IHeadingProps;
import { IManifest } from '@kurtosys/types/appsManager/index.js';

interface EntityStores {
	documentLists: DocumentListStore[];
}
type QueryStore = stores.QueryStore<IConfiguration, IComponentStyles>;

export class EntityStore extends stores.base.StoreBase<IConfiguration, IComponentStyles> {
	queryStore: QueryStore | undefined;
	constructor(storeContext: TStoreContext, manifest: IManifest, entityData?: IEntity) {
		super(storeContext, manifest);
		if (entityData) {
			const appStore = this.storeContext.get<AppStore>('appStore');
			const queryStore = this.storeContext.get<QueryStore>('queryStore');

			const newQueryStore = new stores.QueryStore(storeContext, manifest);
			newQueryStore.context = {
				...(queryStore.context || {}),
				entityByType: {
					[entityData.type]: entityData,
				},
			};
			this.queryStore = newQueryStore;
			this.stores = {
				documentLists: appStore.getDocumentListStores(this),
			};
		}
	}

	async initialize() {
		// Add init code here
	}

	@observable stores: EntityStores = {
		documentLists: [],
	};

	@computed
	get headingProps(): IHeadingProps | undefined {
		const appStore = this.storeContext.get<AppStore>('appStore');
		const { entityGrouping } = appStore;
		if (entityGrouping) {
			const { heading } = entityGrouping;
			if (heading) {
				return this.mergeQueriesAndProps(heading);
			}
		}
		return undefined;
	}

	getQueryValue(
		queryOptions?: IQueryOptions,
		responseForContext?: object,
		overrideExecutionOptions?: Partial<IExecutionOptions>,
	) {
		return super.getQueryValue(queryOptions, responseForContext, overrideExecutionOptions, {
			queryStore: this.queryStore,
		});
	}

	mergeQueriesAndProps<T>(
		componentOrchestration?: IConfigurationComponentOrchestration,
		responseContext?: any,
	): T | undefined {
		return super.mergeQueriesAndProps(componentOrchestration, responseContext, { queryStore: this.queryStore });
	}
}
